import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import { useScrollToTop } from '../../hooks/useScrollToTop';
import {
  SearchVacancies,
  SpontaneousApplication,
  TopVacancies,
  VacancyApplication,
  VacancyDetailsPage,
  VacancyNotFound,
  ApplicationConfirmation,
} from '../../pages';

import { AppRouterProps } from './AppRouter.types';
import { VacanciesRoute } from './routes';

export const AppRouter: FC<AppRouterProps> = ({ scrollElement }) => {
  useScrollToTop(scrollElement);

  return (
    <Routes>
      <Route path={VacanciesRoute.SEARCH_VACANCIES} element={<SearchVacancies />} />
      <Route path={VacanciesRoute.TOP_VACANCY} element={<TopVacancies />} />
      <Route path={VacanciesRoute.VACANCY_DETAILS} element={<VacancyDetailsPage />} />
      <Route path={VacanciesRoute.VACANCY_DETAILS_404} element={<VacancyNotFound />} />
      <Route path={VacanciesRoute.VACANCY_APPLICATION_FORM} element={<VacancyApplication />} />
      <Route
        path={VacanciesRoute.SPONTANEOUS_APPLICATION_FORM}
        element={<SpontaneousApplication />}
      />
      <Route path={VacanciesRoute.APPLICATION_CONFIRMATION} element={<ApplicationConfirmation />} />
      <Route path="*" element={<Navigate to={VacanciesRoute.SEARCH_VACANCIES} />} />
    </Routes>
  );
};
